<template>
    <div class="Email">        
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.56 39.56">
            <g>
                <g>
                    <rect class="cls-1" x=".75" y=".75" width="38.06" height="38.06" rx="19.03" ry="19.03"/>
                    <path id="rect9346" d="M12.41,12.68c-.6,0-1.16,.19-1.61,.52l8.95,5.97,8.98-5.99c-.44-.31-.99-.5-1.58-.5H12.41Zm7.33,8.16l-2.21-1.48-6.63,5.85-.69,.57c.49,.67,1.29,1.11,2.2,1.11h14.75c.9,0,1.7-.43,2.19-1.09l-7.36-6.44-2.25,1.48Zm9.89-6.58l-6.42,4.28,6.64,5.81s0-.06,0-.1V15.31c0-.37-.08-.73-.22-1.05Zm-19.71,.03c-.14,.31-.21,.66-.21,1.02v8.95s0,.03,0,.04l6.58-5.76-6.38-4.25Z"/>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>

import gsap from "gsap"
export default {
  name: 'Email',
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Email
    position relative
    display flex 
    align-items center
    justify-content center
    
    & svg
        width 100%
        .cls-1
            fill none
            stroke #222221
            stroke-miterlimit 10
            stroke-width 1.5px
       
</style>


